
import { computed, defineComponent, onMounted, reactive } from 'vue'

// types
import { ShortcomingFileT, UploadedFileT } from '@/core/types/create_order.types'

// module components
import UploadedFile from '@/modules/InvoiceModule/components/UploadedFile/index.vue'
import { orders } from '@/core/realisations/orders.realisation'

export default defineComponent({
    components: {
        UploadedFile,
    },
    props: {
        orderId: {
            type: Number,
            default: null,
        },
    },
    emits: ['shortcoming'],
    setup(props, { emit }) {
        const state = reactive({
            is_visible: false,
            is_loading: false,
            // shortcoming files
            shortcoming_report_files: [] as UploadedFileT[],
            shortcoming_product_files: [] as UploadedFileT[],
        })

        const editFiles = (files: ShortcomingFileT[]) => {
            return files.map((file) => {
                return {
                    id: file.id,
                    path: file.url,
                    original_name: file.originalName,
                    userEmail: file.userEmail,
                }
            })
        }

        const isShortcomingFiles = computed(() => {
            return state.shortcoming_report_files.length || state.shortcoming_product_files.length
        })

        const loadShortcomingFiles = async () => {
            if (!props.orderId) return

            try {
                state.is_loading = true

                const response = await orders.getShortcomingFiles(props.orderId)

                if (response.data.reportFiles) {
                    state.shortcoming_report_files = editFiles(response.data.reportFiles)
                }

                if (response.data.reportFiles) {
                    state.shortcoming_product_files = editFiles(response.data.productFiles)
                }

                emit('shortcoming', isShortcomingFiles.value)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const toggleShortcomingFiles = () => {
            state.is_visible = !state.is_visible
        }

        //

        const isReportFiles = computed(() => Boolean(state.shortcoming_report_files.length))
        const isProductFiles = computed(() => Boolean(state.shortcoming_product_files.length))
        const userEmail = computed(() => {
            if (isReportFiles.value) {
                return state.shortcoming_report_files[0].userEmail
            }
            if (isProductFiles.value) {
                return state.shortcoming_product_files[0].userEmail
            }

            return '-'
        })
        const getClass = computed(() => {
            return `fas fa-angle-down ShortcomingFiles__icon ${
                state.is_visible ? 'ShortcomingFiles__icon-rotate' : ''
            }`
        })

        //

        onMounted(loadShortcomingFiles)

        //

        return {
            state,
            //
            toggleShortcomingFiles,
            //
            isShortcomingFiles,
            isReportFiles,
            isProductFiles,
            userEmail,
            getClass,
        }
    },
})
